const styles = theme => ({
  menu: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.primary.default + "!important",
    height: "38px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textTransform: "unset",
    paddingLeft: 4,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light
    }
  },

  job: {
    color: theme.palette.primary.light
  },
  cardContainer: {
    width: "100%",
    maxWidth: 350,
    minWidth: 300,
    maxHeight: 360,
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
    boxShadow: `2px 3px 18px rgba(0, 0, 0, .12)`,
    [theme.breakpoints.down("sm")]: {
      marginRight: 0
    }
  },
  root: {
    width: "350px"
  },
  noPictureAvatar: {
    width: "100px",
    height: "100px"
  },
  noPictureForProfile: {
    width: 350,
    height: 140,
    backgroundColor: theme.palette.primary.main
  },
  name: {
    margin: 0,
    color: theme.palette.primary.default
  },
  canPostContianer: {
    color: theme.palette.alt.main,
    fontWeight: "bold"
  },
  switchContainer: {
    marginTop: theme.spacing(2)
  },
  valueColor: {
    color: theme.palette.primary.light
  },
  postPublishedContainer: {
    // marginBottom: theme.spacing(3),
    marginLeft: theme.spacing(1)
  },
  totalPosts: {
    color: theme.palette.primary.default
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/MembersCard/styles.js